import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// ABOUTME: auth slice manages user authentication state and jwt tokens
// ABOUTME: supports multiple roles per user for flexible permissions

export type UserRole =
  | "developer"
  | "tenant-manager"
  | "tenant-owner"
  | "customer";

interface User {
  roles: UserRole[]; // changed from single role to roles array
  email?: string;
  firstName?: string;
  lastName?: string;
  tenantId?: string;
  tenantSlug?: string;
  // legacy support: keep role field temporarily for backward compatibility
  role?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
}

const storedToken = localStorage.getItem("token");
const storedUser = localStorage.getItem("user");

const initialState: AuthState = {
  token: storedToken,
  user: storedUser ? JSON.parse(storedUser) : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string | null>) {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("token", action.payload);
      } else {
        localStorage.removeItem("token");
      }
    },
    setUser(state, action: PayloadAction<User | null>) {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("user");
      }
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("impersonation");
      // Keep tenantBranding in localStorage for themed login page
      state.token = null;
      state.user = null;
    },
  },
});

export const { setToken, setUser, logout } = authSlice.actions;

export default authSlice.reducer;
